var _path, _path2, _path3, _path4, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGooglePlayIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 26,
    viewBox: "9.7 7.4 23.7 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.4352 8.03793C10.1073 8.43 9.9417 8.93263 9.97238 9.44283V31.5589C9.94161 32.0691 10.1072 32.5718 10.4352 32.9638L10.5092 33.0359L22.8982 20.647V20.3547L10.5092 7.96533L10.4352 8.03793Z",
    fill: "url(#gp0)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M27.0276 24.7787L22.8982 20.6473V20.355L27.0286 16.2246L27.1217 16.2777L32.0145 19.0578C33.4121 19.8518 33.4121 21.151 32.0145 21.9455L27.1217 24.7256L27.0276 24.7787Z",
    fill: "url(#gp1)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M27.1216 24.7249L22.8981 20.501L10.4351 32.9639C10.7198 33.215 11.0835 33.3587 11.463 33.3699C11.8426 33.3811 12.2141 33.2592 12.5132 33.0253L27.1216 24.7249Z",
    fill: "url(#gp2)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M27.1216 16.2771L12.5132 7.97666C12.2141 7.74275 11.8426 7.62084 11.463 7.63206C11.0835 7.64327 10.7198 7.7869 10.4351 8.03806L22.8981 20.5011L27.1216 16.2771Z",
    fill: "url(#gp3)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "gp0",
    x1: 21.7995,
    y1: 9.20964,
    x2: 5.01711,
    y2: 25.9921,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.00657,
    stopColor: "#00A1FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2601,
    stopColor: "#00BEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5122,
    stopColor: "#00D2FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7604,
    stopColor: "#00DFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00E3FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "gp1",
    x1: 33.8342,
    y1: 20.5017,
    x2: 9.63727,
    y2: 20.5017,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4087,
    stopColor: "#FFBD00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7754,
    stopColor: "#FFA500"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF9C00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "gp2",
    x1: 24.8266,
    y1: 22.7961,
    x2: 2.06833,
    y2: 45.5544,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF3A44"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C31162"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "gp3",
    x1: 7.29699,
    y1: 0.676237,
    x2: 17.4595,
    y2: 10.8388,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#32A071"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0685,
    stopColor: "#2DA771"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4762,
    stopColor: "#15CF74"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8009,
    stopColor: "#06E775"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00F076"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGooglePlayIcon);
export default __webpack_public_path__ + "static/media/googlePlayIcon.82bfa1b958cc02329ffab4789910e6fc.svg";
export { ForwardRef as ReactComponent };